// @flow
import { generateSchema } from "src/utils/schemaUtils";
import { recordInput } from "src/models/UserModel";
export default generateSchema([], { recordInput });
